import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Row } from 'antd';

import text from './FormDelete.component.translation';

import './FormDelete.style.less';

class FormDelete extends Component {
  render() {
    const {
      intl: { formatMessage },
      linked,
      selectedForm,
      onCloseModal,
      handleDelete,
      isDelete,
      loading,
    } = this.props;

    let buttons = [
      <Button key="btn-return" type="primary" onClick={onCloseModal}>
        {formatMessage(text.btn.return)}
      </Button>,
    ];
    let errorMessage;
    if (!linked) {
      errorMessage = formatMessage(text.error.delete);
    } else {
      buttons = [
        <Button key="btn-cancel" className="btn-cancel" onClick={onCloseModal}>
          {formatMessage(text.btn.cancel)}
        </Button>,
        <Button
          key="btn-delete"
          className="btn-delete"
          type="danger"
          loading={loading}
          onClick={handleDelete}
        >
          {formatMessage(text.btn.delete)}
        </Button>,
      ];
    }
    return (
      isDelete && (
        <Modal
          title={
            <Row className="modal-title-form-builder">
              {formatMessage(text.confirmation.title)}
            </Row>
          }
          visible={isDelete}
          footer={null}
          closable={false}
          className="modal-delete"
        >
          <center>
            {formatMessage(text.confirmation.delete, {
              title: (
                <strong key={selectedForm.name}>{selectedForm.name} </strong>
              ),
            })}
          </center>
          <center className="error-message">{errorMessage}</center>
          <center className="btn-group-delete">{buttons}</center>
        </Modal>
      )
    );
  }
}

FormDelete.propTypes = {
  intl: PropTypes.object,
  linked: PropTypes.bool,
  loading: PropTypes.bool,
  selectedForm: PropTypes.object,
  isDelete: PropTypes.bool,
  onCloseModal: PropTypes.func,
  handleDelete: PropTypes.func,
};

export default FormDelete;
